/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Location_LabelInputs */

const cs_form_location_label = /** @type {(inputs: Form_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Místo`)
};

const en_form_location_label = /** @type {(inputs: Form_Location_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

/**
* | output |
* | --- |
* | "Location" |
*
* @param {Form_Location_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_location_label = /** @type {((inputs?: Form_Location_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Location_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_location_label(inputs)
	return cs_form_location_label(inputs)
});